/** 
 * api接口统一管理
 */
import { post, postform, postoctetstream } from './axios';


/**
 * 
 * @param {string} params 
 * 我们定义了一个topics方法
 * 这个方法有一个参数params
 * params是我们请求接口时携带的参数对象
 * 而后调用了我们封装的post方法
 * post方法的第一个参数是我们的接口地址
 * 第二个参数是topics的params参数
 * 即请求接口时携带的参数对象
 * 最后通过export导出topics。
 */

// 新增鉴价车辆
export const reqAddContactUs = params => post('/audiusedcar/contactUs/addContactUs', params)

// 查询车系+车型列表（鉴价服务中的车型选择列表）
export const reqGetCarSeriesAndModels = params => post('/audiusedcar/car/getCarSeriesAndModels', params)

// 新增鉴价车辆
export const reqAddValuationCar = params => post('/audiusedcar/valuation/addValuationCar', params)

// 查询车款列表
export const reqGetCarStyleList = params => postform('/audiusedcar/car/getCarStyleList', params)

// 查询轮播图列表
export const reqBanners = params => post('/audiusedcar/banner/getBanners', params)

//获取库存列表
export const reqGetCarInventoryList = params => post('/audiusedcar/carInventory/getCarInventoryList', params)

// 下载
export const reqDownLoadPdf = params => postoctetstream('/audiusedcar/carInventory/downLoadPdf', params)


// WEBPACK FOOTER //
// ./src/untils/api.js